var map = {
	"./1.mp3": "68f3",
	"./10.mp3": "6e01",
	"./100.mp3": "197e",
	"./101.mp3": "2a70",
	"./102.mp3": "8c04",
	"./103.mp3": "648c",
	"./104.mp3": "da81",
	"./105.mp3": "c30e",
	"./11.mp3": "1589",
	"./12.mp3": "b11b",
	"./13.mp3": "9023",
	"./14.mp3": "bc52",
	"./15.mp3": "59bc",
	"./16.mp3": "329c",
	"./17.mp3": "ce94",
	"./18.mp3": "0b15",
	"./19.mp3": "e5a1",
	"./2.mp3": "75ad",
	"./20.mp3": "d62d",
	"./21.mp3": "6a52",
	"./22.mp3": "c388",
	"./23.mp3": "3a40",
	"./24.mp3": "6854",
	"./25.mp3": "87e5",
	"./26.mp3": "a00c",
	"./27.mp3": "8539",
	"./28.mp3": "efcb",
	"./29.mp3": "0167",
	"./3.mp3": "8894",
	"./30.mp3": "784d",
	"./31.mp3": "4683",
	"./32.mp3": "f0d7",
	"./33.mp3": "9a43",
	"./34.mp3": "dddd",
	"./35.mp3": "e02d",
	"./36.mp3": "95cd",
	"./37.mp3": "8c9c",
	"./38.mp3": "bd8f",
	"./39.mp3": "7e98",
	"./4.mp3": "8ad2",
	"./40.mp3": "d30e",
	"./41.mp3": "4ebf",
	"./42.mp3": "0393",
	"./43.mp3": "cc6c",
	"./44.mp3": "cc02",
	"./45.mp3": "82f6",
	"./46.mp3": "eab4",
	"./47.mp3": "4b7d",
	"./48.mp3": "a58e",
	"./49.mp3": "ceb5",
	"./5.mp3": "4ddd",
	"./50.mp3": "eba4",
	"./51.mp3": "7f3a",
	"./52.mp3": "a0f2",
	"./53.mp3": "5001",
	"./54.mp3": "50f3",
	"./55.mp3": "fcd5",
	"./56.mp3": "a0a9",
	"./57.mp3": "2e3a",
	"./58.mp3": "5335",
	"./59.mp3": "2aae",
	"./6.mp3": "9b33",
	"./60.mp3": "4228",
	"./61.mp3": "186e",
	"./62.mp3": "033a",
	"./63.mp3": "69f5",
	"./64.mp3": "79d1",
	"./65.mp3": "8844",
	"./66.mp3": "12e1",
	"./67.mp3": "e38a",
	"./68.mp3": "54e3",
	"./69.mp3": "09b9",
	"./7.mp3": "3cfa",
	"./70.mp3": "202e",
	"./71.mp3": "b2a1",
	"./72.mp3": "4345",
	"./73.mp3": "ea9e",
	"./74.mp3": "7ed6",
	"./75.mp3": "8446",
	"./76.mp3": "1dfb",
	"./77.mp3": "de36",
	"./78.mp3": "1a20",
	"./79.mp3": "d41d",
	"./8.mp3": "44336",
	"./80.mp3": "c17b",
	"./81.mp3": "4219",
	"./82.mp3": "0b82",
	"./83.mp3": "0378",
	"./84.mp3": "e613",
	"./85.mp3": "1cdd",
	"./86.mp3": "5a1d",
	"./87.mp3": "2ada",
	"./88.mp3": "44dd",
	"./89.mp3": "7762",
	"./9.mp3": "3840",
	"./90.mp3": "4d93",
	"./91.mp3": "4bec",
	"./92.mp3": "8abd",
	"./93.mp3": "142d",
	"./94.mp3": "99a7",
	"./95.mp3": "1b77",
	"./96.mp3": "cfe0",
	"./97.mp3": "d018",
	"./98.mp3": "fb6b",
	"./99.mp3": "07f4",
	"./gamend.mp3": "0eb1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f372";